import { Link } from 'react-router-dom';
import {
  ExclamationTriangleIcon,
  HomeIcon,
  ArrowLeftIcon,
} from '@heroicons/react/24/outline';

function PageNotFound() {
  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md text-center">
        {/* Icon */}
        <div className="mx-auto w-20 h-20 rounded-full bg-amber-100 flex items-center justify-center mb-6">
          <ExclamationTriangleIcon className="w-10 h-10 text-amber-500" />
        </div>

        {/* Error Code */}
        <p className="text-7xl font-light text-sky-500 mb-4">404</p>

        {/* Message */}
        <h1 className="text-2xl sm:text-3xl font-light tracking-tight text-slate-900 mb-3">
          Page Not Found
        </h1>
        <p className="text-slate-500 mb-8">
          Sorry, we couldn't find the page you're looking for. It might have
          been moved or deleted.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 bg-sky-500 hover:bg-sky-600 text-white font-medium py-3 px-6 rounded-xl transition-all duration-200 text-sm"
          >
            <HomeIcon className="w-4 h-4" />
            Go to Home
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2 bg-white border border-slate-300 hover:border-sky-300 text-slate-700 hover:text-sky-600 font-medium py-3 px-6 rounded-xl transition-all duration-200 text-sm"
          >
            <ArrowLeftIcon className="w-4 h-4" />
            Go Back
          </button>
        </div>

        {/* Help Text */}
        <p className="text-xs text-slate-400 mt-8">
          Need help? <Link to="/contact" className="text-sky-600 hover:text-sky-500">Contact our support team</Link>
        </p>
      </div>
    </div>
  );
}

export default PageNotFound;
